import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './eventParameters.module.scss';

export const EventParameters = ({ event }) => {
    return (
        <div className={styles['section']}>
            <div className={styles['header-row']}>
                <div className={styles['section-title']}>
                    <FormattedMessage id="codeless.event.parameters.title" defaultMessage="Parameters" />
                </div>
                <div className={styles['section-content']}>
                    {event.includeInTotalConversions && (
                        <FormattedMessage
                            id="codeless.event.parameters.include"
                            defaultMessage="<strong>Include in total conversions</strong>"
                        />
                    )}
                </div>
            </div>
            {event.trackedElements?.[0]?.valueSelector && (
                <div className={styles['header-row']}>
                    <div className={styles['section-title']} />
                    <div className={styles['section-content']}>
                        <FormattedMessage
                            id="event.parameters.value"
                            defaultMessage="Value is {value}"
                            values={{ value: event.trackedElements[0]?.valueSelector }}
                        />
                    </div>
                </div>
            )}
            {event.trackedElements?.[0]?.currency && (
                <div className={styles['header-row']}>
                    <div className={styles['section-title']} />
                    <div className={styles['section-content']}>
                        <FormattedMessage
                            id="event.parameters.currency"
                            defaultMessage="Currency: {currency}"
                            values={{ currency: event.trackedElements[0]?.currency }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
